import styles from '../InitBooking.module.scss'
import { Placeholder } from 'react-bootstrap'

interface Props {
  navType: 'wizard' | 'lead' // wizard = embedded in booking wizard | lead = embedded in other page
}
const InitBookingLoadingPlaceholder = ({ navType }: Props) => {
  return (
    <>
      <div className={`${styles.root} ${styles[navType]}`}>
        <div className={styles.header}>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={7} className={'mb-3'} />
            <Placeholder xs={12} />
          </Placeholder>
        </div>
        <div className={styles.basePrice}>
          <Placeholder as="p" animation="glow" className={'mb-3'}>
            <Placeholder xs={12} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} className={'mb-3'} />
            <Placeholder xs={12} className={'mb-3'} />
          </Placeholder>
        </div>
      </div>
    </>
  )
}

export default InitBookingLoadingPlaceholder
